import React, { useState } from "react";
import PanelTemplate from "../../shares/PanelTemplate";
import { useForm } from "react-hook-form";
import MuiButton from "../../shares/MuiButton";
import MuiTextFieldHook from "../../shares/MuiTextFieldHook";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MuiComboBox from "../../shares/MuiComboBox";
import { useUserData } from "../../../context/UserDataContext";
import useFetch from "../../../context/useFetch";
import { toast } from "react-toastify";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import ClearIcon from "@mui/icons-material/Clear";
import MuiTextField from "../../shares/MuiTextField";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import moment from "jalali-moment";
import { EmptyData, fixNumbers, translateState } from "../../../utils";

const AdminRemoveOrder = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {},
  });

  const { userData } = useUserData();

  const [selectedCustomer, setSelectedCustomer] = useState(undefined);

  const [openModal, setOpenModal] = useState(false);
  const [orderDetail, setOrderDetail] = useState(null);
  const [searchedCustomerText, setSearchedCustomerText] = useState("");
  const [adminCustomersList, setAdminCustomersList] = useState({
    results: [],
  });
  const [orderCode, setOrderCode] = useState(null);

  const getOrderApi = useFetch({
    method: "post",
    url: `Order_Service/get_order_using_order_id`,
    trigger: false,
    data: {
      unique_id: fixNumbers(orderCode),
    },
    argFunc: (res) => {
      setOrderDetail(res);
    },
    errMessage: (mess) => {
      toast.error("شماره سند وجود ندارد", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const show_order_details = () => {
    if (orderCode !== null) {
      getOrderApi.reFetch();
    }
  };

  const updateOrderApi = useFetch({
    method: "patch",
    url: `Order_Service/${orderDetail?.id}/remove_order`,
    trigger: false,
    data: {
      state: "cancel",
    },
    argFunc: (res) => {
      toast.success("سفارش با موفقیت  حذف شد", {
        position: toast.POSITION.TOP_CENTER,
      });
      setOpenModal(false);
      getOrderApi.reFetch();
      window.location.reload();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handelChangeState = () => {
    updateOrderApi.reFetch();
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink={"q-remove-order"}>
        <div className="panel-main-header">
          <span className="">{"حذف سفارش"}</span>
        </div>

        <div className="grid md:grid-cols-5 gap-y-6 gap-x-4 border-dashed border-b pb-4">
          <div className="col1">
            <MuiTextField
              id="outlined-basic"
              label="شماره سند"
              variant="outlined"
              size="small"
              name="name"
              control={control}
              onChange={(e) => setOrderCode(e.target.value)}
              register={{
                required: {
                  value: true,
                  message: "شماره سند را وارد کنید.",
                },
              }}
            />
          </div>

          <div className="col2 ">
            <MuiButton
              onClick={show_order_details}
              variant="contained"
              icon={<ArrowDownwardIcon />}
              color="primary"
              text=" نمایش اطلاعات سفارش "
              disabled={getOrderApi.loading}
            />
          </div>
        </div>

        {orderDetail ? (
          <>
            {orderDetail?.state !== "cancel" &&
            orderDetail?.state !== "complete" ? (
              <div className="grid md:grid-cols-5 gap-y-6 gap-x-4 border-dashed border-b pb-4 mt-4">
                <div className="flex items-center">
                  <KeyboardDoubleArrowLeftIcon
                    sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
                  />
                  <span className="show-label">
                    تاریخ سفارش:{" "}
                    <span className="show-value">
                      {moment(orderDetail?.created_at, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </span>
                  </span>
                </div>
                <div className="flex items-center">
                  <KeyboardDoubleArrowLeftIcon
                    sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
                  />
                  <span className="show-label">
                    مشتری فعلی:{" "}
                    <span className="show-value">{orderDetail?.name}</span>
                  </span>
                </div>
                <div className="flex items-center">
                  <KeyboardDoubleArrowLeftIcon
                    sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
                  />
                  <span className="show-label">
                    جمع وزن فعلی سفارش:{" "}
                    <span className="show-value">{orderDetail?.total}</span>
                  </span>
                </div>
                <div className="flex items-center">
                  <KeyboardDoubleArrowLeftIcon
                    sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
                  />
                  <span className="show-label">
                    وضعیت سفارش:{" "}
                    <span className="show-value">
                      {translateState(orderDetail?.state)}
                    </span>
                  </span>
                </div>
              </div>
            ) : (
              //   "سفارش در وضعیت حذف یا کامل شده می باشد "
              <EmptyData text="سفارش در وضعیت حذف یا کامل شده می باشد  !" />
            )}
          </>
        ) : null}

        {orderDetail?.state !== "cancel" &&
        orderDetail?.state !== "complete" ? (
          <div className="flex justify-end mt-4 mr-4">
            <MuiButton
              onClick={handelChangeState}
              variant="contained"
              icon={<TransferWithinAStationIcon />}
              color="success"
              text={"حذف سفارش"}
              disabled={orderDetail == null || updateOrderApi.loading}
            />
          </div>
        ) : undefined}
      </PanelTemplate>
    </>
  );
};

export default AdminRemoveOrder;
